





























































































































































import { defineComponent, toRefs, PropType, ref, computed } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  AcoFormData,
  DeepLinkType,
  ACTION_TYPE,
  NormalCreative,
  VerticalCreativeStrategy,
} from '@tt4b/ttam-enums';

import {
  useCreativeDeepLinkValidate,
  useDeepLinkFormStatus,
  useIsNotSupportProductLink,
  useStdCreativeIs,
  getOriginalQuery,
  param2Utm,
  generateCustomParams,
  useUtmUpdateHook,
} from '@tt4b/ttam-hooks';
import TtamBackgroupdContainer from '@/components/common/background-container/index.vue';
import CreativeDeepLink from '../index';
import FallbackCompose from '../productsales-fallback-compose/index.vue';
import QuestionTooltipWithImage from '@/components/common/question-tooltip-with-image/index.vue';
import CatalogCarouselProductsUrlsTipPng from '@tt4b/ttam-assets/src/images/creative/catalog-carousel-products-urls-tip.png';
import CatalogCarouselSwipeLeftTipPng from '@tt4b/ttam-assets/src/images/creative/catalog-carousel-swipe-left-tip.png';
import CreativeProductTileSwipeLeftTipPng from '@tt4b/ttam-assets/src/images/creative/creative-product-tile-swipe-left-tip.png';
import CreativeProductTileTipPng from '@tt4b/ttam-assets/src/images/creative/creative-product-tile-tip.png';
import CreativeWebsiteUrl from '../../creative-website-url/index';
import { parseUrl } from 'query-string';
import { isEmpty } from 'lodash-es';

const name = 'ttam-creative-productsales-deeplink-compose';
export default defineComponent({
  name,
  components: {
    QuestionTooltipWithImage,
    FallbackCompose,
    TtamBackgroupdContainer,
    TtamCreativeDeepLinkInput: CreativeDeepLink.TtamCreativeDeepLinkInput,
    TtamCreativeDeepLinkPreviewDialog: CreativeDeepLink.TtamCreativeDeepLinkPreviewDialog,
    TtamCreativeDeepLinkDpaSelect: CreativeDeepLink.TtamCreativeDeepLinkDpaSelect,
    TtamCreativeDeepLinkDpaInputFormLabel: CreativeDeepLink.TtamCreativeDeepLinkDpaInputFormLabel,
    TtamCreativeUtmEntry: CreativeWebsiteUrl.TtamCreativeUtmEntry,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    rejectReason: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    createMode: {
      type: String,
      default: () => ACTION_TYPE.CREATE,
    },
    currentAdgroupIdCreativeList: {
      type: Array as PropType<NormalCreative[]>,
      default: () => [],
    },
    isDisabledCreative: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, creativeData, currentAdgroupIdCreativeList, createMode, isDisabledCreative } =
      toRefs(props);

    const { isNotSupportProductLink: onlySupportCustomLink } = useIsNotSupportProductLink({
      creativeData,
      adgroupData,
    });

    const originalQuery = getOriginalQuery({
      creativeData,
      isOpenUrl: true,
      overrideUrl: false,
      openUrlProp: ref(''),
    });

    const { handleUtmUpdate, checkEmitUtm, hasAppliedUtm, handleAppliedUtm, handleBuilderUtm } = useUtmUpdateHook({
      formData: creativeData,
      emit,
      isVsa: true,
      isOpenUrl: true,
      originalQuery,
      setFormData: () => () => ({}),
    });

    const previewDialogVisible = ref(false);
    const onCheckButtonClick = () => {
      previewDialogVisible.value = true;
    };
    const onPreviewModalClose = () => {
      previewDialogVisible.value = false;
    };

    const { isSingleVideo } = useStdCreativeIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
      creativeFormData: creativeData,
    });

    const _openUrl = computed({
      get: () => creativeData.value.openUrl,
      set: (newV: string) => {
        handleUtmUpdate(newV);
        checkEmitUtm(newV);
        emit('open-url-change', newV);
      },
    });

    const viDeeplinkTypeRef = ref();
    const _dpaOpenUrlType = computed({
      get: () => creativeData.value.dpaOpenUrlType || '',
      set: val => {
        // isProductDeepLink
        if (val === 1) {
          _openUrl.value = '';
        }

        emit('open-url-type-change', val);
        emit('open-url-utms-change', []);
        handleAppliedUtm(false);

        // eslint-disable-next-line
        viDeeplinkTypeRef.value?.validate?.();
      },
    });

    const onFallbackTypeChange = (val: DeepLinkType) => {
      emit('fallback-type-change', val);
    };

    const onFallbackUrlChange = (val: string) => {
      emit('fallback-url-change', val);
    };

    const onFallbackUtmsChange = utms => {
      emit('utms-change', utms);
    };

    const { deepLinkTypeValidator, deepLinkUrlValidator } = useCreativeDeepLinkValidate({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });
    const isOpenUrlEmpty = computed(() => isEmpty(_openUrl.value));
    const checkButtonVisible = computed(() => creativeData.value.isOpenUrl && !isOpenUrlEmpty.value);

    // const previewDialogVisible = computed(() => creativeData.value.isOpenUrl && creativeData.value.openUrl);

    const { isSalesShowDeeplinkCustomInput: deepLinkUrlVisible } = useDeepLinkFormStatus({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
      creativeFormData: creativeData,
    });

    const { disabled: fallbackDisabled } = CreativeDeepLink.useFallBackPropsDisabled({
      adgroupData,
      campaignData,
      creativeData,
      createMode,
      currentAdgroupIdCreativeList,
      isDisabledCreative,
    });
    // 由于解释文案不匹配，smart creative 暂时不用新UI
    const isEntryNewUI = computed(
      () =>
        _dpaOpenUrlType.value === DeepLinkType.CustomeLink &&
        deepLinkUrlVisible.value &&
        onlySupportCustomLink.value &&
        creativeData.value.verticalCreativeStrategy !== VerticalCreativeStrategy.SMART_CREATIVE,
    );

    const handleApplyUtm = (newParams: string): void => {
      const hasUrlScene = _dpaOpenUrlType.value === DeepLinkType.CustomeLink;
      if (!hasAppliedUtm.value) {
        handleAppliedUtm(true);
      }

      if (hasUrlScene) {
        const { url } = parseUrl(_openUrl.value);
        handleBuilderUtm(true);
        const originCustomParams = generateCustomParams(originalQuery.value);
        _openUrl.value = originCustomParams
          ? `${url}?${originCustomParams}&${newParams.slice(1)}`
          : `${url}${newParams}`;
      } else {
        const newUtms = param2Utm(newParams);
        emit('open-url-utms-change', newUtms);
      }
    };

    return {
      name,
      onFallbackTypeChange,
      onFallbackUrlChange,
      onFallbackUtmsChange,

      viDeeplinkTypeRef,
      _dpaOpenUrlType,
      _openUrl,
      previewDialogVisible,
      checkButtonVisible,
      onCheckButtonClick,
      onPreviewModalClose,
      deepLinkTypeValidator,
      deepLinkUrlValidator,
      handleApplyUtm,
      originalQuery,
      deepLinkUrlVisible,
      fallbackDisabled,
      DeepLinkType,
      onlySupportCustomLink,
      isEntryNewUI,
      isSingleVideo,
      // image
      CatalogCarouselProductsUrlsTipPng,
      CatalogCarouselSwipeLeftTipPng,
      CreativeProductTileSwipeLeftTipPng,
      CreativeProductTileTipPng,
    };
  },
});
